import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { icons } from '~/assets';
import Container from '~/components/container';
import Dialog from '~/components/dialog';

import * as St from './styles';
import HeaderConference from '../../AntecipationPurchase/components/headerConference';
import ListConference from '../../AntecipationPurchase/components/listConference';
import ContainerFlex from '~/components/containerFlex';
import moment from 'moment';
import { currencyMask } from '~/utils/masks';
import Button from '~/components/button';

const AntecipationInvoiceConference: React.FC = () => {
  const history = useHistory<any>();
  const locationState = history.location.state;

  const [valorTotal, setValorTotal] = useState('');
  const [dialog, setDialog] = useState({ open: false, error: false });
  const [dialogMessage, setDialogMessage] = useState('');
  const [data, setData] = useState(null);
  const [descontoTotal, setDescontoTotal] = useState('');

  useEffect(() => {
    const value = [];
    locationState?.dataFinancial?.map((dataP) => {
      if (dataP.parcelasAAntecipar > 0) {
        value.push(dataP);
      }
      return dataP;
    });
    setData(value);
  }, []);

   useEffect(() => {
      async function populaValor() {
        let aux = 0;
        let auxDesconto = 0;
        if (data) {
          setValorTotal('');
          setDescontoTotal('');
          data.map((item) => {
            aux = item.valorAntecipacao + aux;
          });
          data.map((item) => {
            auxDesconto = item.valorDesconto + auxDesconto;
          })
          setValorTotal(String(aux));
          setDescontoTotal(String(auxDesconto));
        }
      }
  
      populaValor();
    }, [data]);

  function handleClick() {
    history.push('/invoice/advance-financing/payment', {
      locationState
    });
  }

  return (
    <Container>
      <Dialog
        icon={dialog?.error ? icons.exclamation : icons.check}
        open={dialog?.open}
        positiveLabel="Entendi"
        positiveAction={() => {
          if (!dialog.error) {
            history.push('');
          }
          setDialog({ open: false, error: false });
        }}
        message={dialogMessage}
      />
      {data?.length > 0 ? (
        <>
          <HeaderConference
            nomeCompleto={data[0]?.nomeCompleto}
            cpf={data[0]?.cpf}
            numeroCartao={data[0]?.cartao}
            valorTotal={Number(valorTotal)}
            data={locationState?.dataFinancial}
            financial
            descontoTotal={Number(descontoTotal)}
          />

          <St.BoxCard>
            <ListConference data={data} typeList="FINANCIAL"/>

            <ContainerFlex marginBottom={20}>
              <ContainerFlex row marginLeft={20}>
              <St.IconExclamation src={icons.exclamation} alt="Logo TeuCard" />
              <St.DescriptionInfo>ANTECIPAÇÃO DE FINANCIAMENTO</St.DescriptionInfo>
              </ContainerFlex>
              <ContainerFlex marginLeft={18}>
                <St.DescriptionInfo>
                  {`Comunique o cliente para realizar o pagamento em até 24h. Caso não seja realizado o pagamento, a solicitação é automaticamente cancelada. 
                    O valor total a pagar é R$ ${currencyMask(
                      Number(valorTotal),
                  )}. Confirma a antecipação?`}
                </St.DescriptionInfo>
              </ContainerFlex>
            </ContainerFlex>

            <ContainerFlex row end padding={15}>
              <Button
                fitContent
                onClick={handleClick}
              >
                <span>Escolher Pagamento</span>
              </Button>
            </ContainerFlex>
          </St.BoxCard>
        </>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default AntecipationInvoiceConference;
